import {useCallback} from 'react';

import {useTranslation} from 'hooks';

export const useInfo = () => {
    const translate = useTranslation();

    return useCallback(member => {
        const ret = memberInfo(member);

        ret.trainer = '';
        if (member.roles.includes('trainer')) {
            ret.trainer = '(' + translate('client.role.trainer') + ')';
        }

        ret.roles = member.roles.map(role => translate(`client.role.${role}`)).join(', ');

        return ret;
    }, [translate]);
};

export const memberInfo = (member) => {
    let usePlaceHolder = false;
    let firstname = member?.user?.firstname || member?.firstname || '';
    let lastname = member?.user?.lastname || member?.lastname || '';
    if (firstname === '' && lastname === '')
        usePlaceHolder = true;
    const initials = !usePlaceHolder ? firstname?.charAt(0) + lastname?.charAt(0) : 'S';
    const name = !usePlaceHolder ? `${firstname} ${lastname}`.trim() : 'Spieler ' + member?.number;
    
    // console.log('memberInfo', name, initials);
    return {firstname, lastname, name, initials};
};